<template>
  <div class="wrap" :style="{width: width}">
    <el-cascader
      width="100%"
      expand-trigger="hover"
      :options="options"
      v-model="addressValue"
      placeholder=" "
      @focus="focus"
      @blur="blur"
      @change="change">
    </el-cascader>
    <div v-if="loading" class="auto-loading">
      <p>自动定位中</p>
      <p>·</p>
      <p>·</p>
      <p>·</p>
    </div>
    <label class="placeholder" :class="lableClass">
      <span v-if="isImportant" class="important">*</span>
      <span>{{placeholder}}</span>
    </label>
  </div>
</template>

<script>
// 获取这个组件的地址数据，在调用的地方传入 @getdata=“xxxxx”  这个函数会返回选择器的数据  每次组件失焦的时候会自动更新
import address from '@/assets/js/area'
import cityOptions from '@/config/cityOptions'
import { constants } from 'crypto';

export default {
  data() {
    return {
      isFocus: false,
      lableClass: 'placeholder',
      province_code: '',
      city_code: '',
      district_code: '',
      options: '',
      loading: false
    }
  },

  props: {
    value: {},

    optionData: {},

    placeholder: {
      type: String,
      default: '请输入'
    },

    width: {
      type: String,
      default: '100%'
    },

    isImportant: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    addressValue: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  },

  watch: {
    addressValue(val) {
      this.$nextTick(() => {
        if (val.length === 0) {
          this.lableClass = 'placeholder'
        } else if (this.isFocus) {
          this.lableClass = 'focus'
        } else {
          this.lableClass = 'blur'
        }
      })
    }
  },

  created() {
    // 这个系统的地址数据分为利楚地区的编码信息和百度地区的编码信息，百度的要精准一些，只有百度的编码可以使用自动定位
    if (!this.optionData) {
      this.loading = true
      this.autoGetAdress()
    } else {
      this.options = this.optionData
    }
    
  },

  methods: {
    autoGetAdress() {
      this.openMessage(1, '正在自动获取定位', {duration: 2000})
      this.options = cityOptions
      var that = this
      // 调用百度地图的接口
      const geolocation = new BMap.Geolocation()
      geolocation.getCurrentPosition(function(r) {
        new BMap.Geocoder().getLocation(r.point, function(res) {
          that.loading = false
          let addComp = res.addressComponents
          let getAddress = address.initProviceAndCityCode(addComp.province, addComp.city, addComp.district)
          that.province_code = addComp.province
          if (addComp.province) {  // 如果网比较慢，用户自己已经填了
            if (that.addressValue.length === 0) that.addressValue = [getAddress.province_code, getAddress.city_code, getAddress.district_code]
          } else {
            that.openMessage(0, '您的浏览器不支持自动获取位置')
          }
        })
      })
    },

    focus() {
      this.isFocus = true;
      this.lableClass = 'focus'
    },

    blur() {
      setTimeout(() => {
        // this.addressValue第一时间改变不过来，会和watch冲突，造成跳动
        if (this.addressValue.length === 0) {
          this.lableClass = 'placeholder'
        }
      }, 200);
      this.isFocus = false;
      this.lableClass = 'blur'
    },

    change() {
      this.loading = false
    }
  },

  components: {
    
  }
};
</script>

<style lang="scss" scoped>
@keyframes identifier {
    25% {
        color: rgba(51, 51, 51, 0.6)
    }
    50% {
        color: rgba(51, 51, 51, 0.4)
    }
    75% {
        color: rgba(51, 51, 51, 0.2)
    }
}
.wrap {
  position: relative;
  width: 100%;
  min-width: 150px;
  font-size: 14px;

  /deep/ .el-cascader {
    width: 100%;
  }

  .placeholder {
    position: absolute;
    left: 15px;
    top: 20px;
    margin-top: -7px;
    transform-origin: 0 0;
    background: #fff;
    color: #c1c4cc;
    transition: all .25s;
    pointer-events: none;
  }

  .auto-loading {
    display: flex;
    flex-wrap: wrap;
    position: absolute;
    top: 1px;
    left: 1px;
    width: 98%;
    height: 42px;
    padding-left: 190px;
    line-height: 42px;
    color: #999999;
    background: #FFFFFF;
    cursor: pointer;
    pointer-events: none;

    p:first-child {
      margin-right: 5px;
    }

    p:nth-of-type(2) {
      font-size: 22px;
      font-weight: bold;
      animation: identifier 1s infinite linear;
    }

    p:nth-of-type(3) {
      font-size: 22px;
      font-weight: bold;
      animation: identifier 1s infinite linear;
      animation-delay: 0.3s;
    }

    p:nth-of-type(4) {
      font-size: 22px;
      font-weight: bold;
      animation: identifier 1s infinite linear;
      animation-delay: 0.6s;
    }
  }

  .important {
    position: relative;
    top: 3px;
    margin-right: 2px;
    font-size: 16px;
    font-weight: bold;
    color: #E51C23;
  }

  .focus {
    font-size: 12px;
    color: #08A681;
    padding: 0 3px;
    font-weight: bolder;
    letter-spacing: 0;
    line-height: 16px;
    transform: translate(-2px, -22px);
  }

  .blur {
    font-size: 12px;
    color: #666666;
    padding: 0 3px;
    letter-spacing: 0;
    line-height: 16px;
    transform: translate(-2px, -22px);
  }
}
</style>
